(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3200],{

/***/ 2258:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/managed-services",
      function () {
        return __webpack_require__(9738);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ CustomerSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _hooks_useInView__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5467);
/* harmony import */ var _utils_clients__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1358);





var CustomerSection = function(param) {
    var _title = param.title, title = _title === void 0 ? "Our Valued Customers" : _title;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_hooks_useInView__WEBPACK_IMPORTED_MODULE_1__/* .useInView */ .Y)({
        threshold: 0.25
    }), 2), ref1 = ref[0], inView = ref[1];
    // Duplicate for seamless loop
    var marqueeItems = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_utils_clients__WEBPACK_IMPORTED_MODULE_2__/* .namedClients */ .e).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_utils_clients__WEBPACK_IMPORTED_MODULE_2__/* .namedClients */ .e));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        ref: ref1,
        className: "px-4 mt-5 mb-5 text-black w-full flex flex-col items-center transition-all duration-700 ease-out transform ".concat(inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "rounded-2xl w-full mt-4",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "lg:text-4xl text-2xl font-bold text-black text-center lg:mb-6 mb-4",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute inset-y-0 left-0 w-24 pointer-events-none z-10 bg-gradient-to-r from-white to-transparent"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute inset-y-0 right-0 w-24 pointer-events-none z-10 bg-gradient-to-l from-white to-transparent"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex animate-marquee gap-0",
                            children: [
                                0,
                                1
                            ].map(function(copy) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex flex-shrink-0 items-center gap-8 px-4",
                                    children: _utils_clients__WEBPACK_IMPORTED_MODULE_2__/* .namedClients.map */ .e.map(function(client) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: client.url !== "#" ? client.url : undefined,
                                            target: client.url !== "#" ? "_blank" : undefined,
                                            rel: "noopener noreferrer",
                                            className: "flex-shrink-0 flex items-center justify-center",
                                            title: client.name,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "h-12 w-28 flex items-center justify-center rounded-lg px-2 ".concat(client.darkBg ? "bg-gray-800" : "bg-gray-50"),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: client.logo,
                                                    alt: client.name,
                                                    className: "max-h-8 max-w-full object-contain"
                                                })
                                            })
                                        }, "".concat(copy, "-").concat(client.name));
                                    })
                                }, copy);
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 3230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useScreenSize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5344);


var Navbar = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7804), __webpack_require__.e(7196)]).then(__webpack_require__.bind(__webpack_require__, 7804));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7804)
            ];
        }
    },
    ssr: false
});



function Service2(param) {
    var heading = param.heading, paragraph = param.paragraph, bgPath = param.bgPath, textColor = param.textColor, mainHeading = param.mainHeading, styleClass = param.styleClass, _primaryCta = param.primaryCta, primaryCta = _primaryCta === void 0 ? null : _primaryCta, _heroSvg = param.heroSvg, heroSvg = _heroSvg === void 0 ? null : _heroSvg;
    var size = (0,_hooks_useScreenSize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var isSmall = size == "sm" || size == "md";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Navbar, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "h-fit max-h-auto flex items-center pt-12 ".concat(styleClass),
                style: {
                    backgroundImage: isSmall && !heroSvg ? "url('".concat(bgPath, "')") : ""
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                        className: "".concat(heroSvg ? "" : "opacity-[0.7] md:opacity-100", " w-[100%] md:w-[65%] h-fit max-h-auto flex flex-col px-6 pb-16 pt-[50px] md:pt-12 ").concat(textColor ? textColor : "text-services-main-txt", " service_txt  "),
                        children: [
                            mainHeading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-2xl font-bold md:text-3xl py-6",
                                children: mainHeading
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "text-3xl font-bold md:text-5xl py-3",
                                children: heading
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xl pt-8 whitespace-pre-line",
                                dangerouslySetInnerHTML: {
                                    __html: paragraph
                                }
                            }),
                            primaryCta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                href: primaryCta.href,
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "mt-8 inline-block self-start bg-[#f1aa4e] text-black font-semibold text-base px-6 py-3 rounded-md hover:bg-[#e09a3e] transition-colors",
                                    children: primaryCta.label
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: heroSvg ? "hidden md:flex items-center justify-center w-[35%] py-16 px-8" : "",
                        children: heroSvg ? heroSvg : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: bgPath,
                            className: "w-auto h-[0vh] md:min-h-[100vh] mx-auto object-cover",
                            width: "500",
                            height: "500",
                            alt: "how-digitisation-helps-formulation-companies",
                            sizes: "(max-width: 500px) 50vw, (max-width: 1200px) 70vw, 100vw",
                            placeholder: "blur",
                            blurDataURL: bgPath
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Service2);


/***/ }),

/***/ 2616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ServiceFAQ; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


function ServiceFAQ(param) {
    var _items = param.items, items = _items === void 0 ? [] : _items;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), openIndex = ref[0], setOpenIndex = ref[1];
    if (!items.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "px-8 md:px-[60px] py-12 bg-white",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-4xl mx-auto",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center",
                    children: "Frequently asked questions"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "divide-y divide-gray-200 border-t border-gray-200",
                    children: items.map(function(item, idx) {
                        var isOpen = openIndex === idx;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "py-5",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    onClick: function() {
                                        return setOpenIndex(isOpen ? null : idx);
                                    },
                                    className: "w-full flex justify-between items-start gap-4 text-left group",
                                    "aria-expanded": isOpen,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-base md:text-lg font-semibold text-gray-900 group-hover:text-blue-600 transition-colors",
                                            children: item.q
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "flex-shrink-0 mt-0.5 text-gray-500 group-hover:text-blue-600 transition-colors",
                                            children: isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                className: "w-5 h-5",
                                                fill: "none",
                                                stroke: "currentColor",
                                                viewBox: "0 0 24 24",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    strokeWidth: 2,
                                                    d: "M5 15l7-7 7 7"
                                                })
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                className: "w-5 h-5",
                                                fill: "none",
                                                stroke: "currentColor",
                                                viewBox: "0 0 24 24",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    strokeWidth: 2,
                                                    d: "M19 9l-7 7-7-7"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "mt-4 ".concat(isOpen ? "block" : "hidden"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-gray-600 text-base leading-relaxed",
                                            children: item.a
                                        }),
                                        item.link && item.linkLabel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                            href: item.link,
                                            className: "mt-3 inline-block text-sm font-semibold text-blue-600 hover:text-blue-800 transition-colors",
                                            children: [
                                                item.linkLabel,
                                                " →"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, idx);
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 2100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SuccessStoryEmbed; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _blogs_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2684);





var allCaseStudies = _blogs_json__WEBPACK_IMPORTED_MODULE_3__.filter(function(item) {
    var ref;
    return (item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category) === "case-study";
}).map(function(item) {
    return {
        title: item.meta.title || "",
        slug: item.meta.slug || "",
        img: item.meta.img || null,
        industry_descriptor: item.meta.industry_descriptor || null,
        outcome_metric: item.meta.outcome_metric || null,
        refer: Array.isArray(item.meta.refer) ? item.meta.refer : [],
        date: item.meta.date || ""
    };
});
function SuccessStoryEmbed(param) {
    var referTag = param.referTag, _maxItems = param.maxItems, maxItems = _maxItems === void 0 ? 3 : _maxItems, _heading = param.heading, heading = _heading === void 0 ? "Work we've shipped for clients like you" : _heading;
    var stories = referTag ? allCaseStudies.filter(function(s) {
        return s.refer.includes(referTag);
    }) : [];
    if (stories.length === 0) {
        stories = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(allCaseStudies).sort(function(a, b) {
            return b.date > a.date ? 1 : -1;
        });
    }
    var visible = stories.slice(0, maxItems);
    if (!visible.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "py-12 px-6 md:px-[60px] bg-gray-50 text-left",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-6xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-left",
                    children: heading
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-3 gap-6 mb-8",
                    children: visible.map(function(story) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/blog/".concat(story.slug),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                className: "group bg-white border border-gray-200 rounded-xl overflow-hidden hover:border-blue-400 hover:shadow-md transition-all flex flex-col",
                                children: [
                                    story.img && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "relative w-full h-44 bg-gray-100",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            src: story.img,
                                            alt: story.title,
                                            fill: true,
                                            className: "object-cover",
                                            sizes: "(max-width: 768px) 100vw, 400px",
                                            placeholder: "blur",
                                            blurDataURL: "/blogImages/hero/placeholder.webp"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "p-5 flex flex-col flex-1",
                                        children: [
                                            story.industry_descriptor && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-blue-500 text-xs uppercase tracking-wide font-medium mb-2",
                                                children: story.industry_descriptor
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: "text-base font-semibold text-gray-900 group-hover:text-blue-600 transition-colors leading-snug mb-3 flex-1",
                                                children: story.title
                                            }),
                                            story.outcome_metric && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-sm text-gray-500 mt-auto pt-3 border-t border-gray-100",
                                                children: story.outcome_metric
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, story.slug);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/success-stories",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "inline-block border border-gray-300 hover:border-blue-500 text-gray-700 hover:text-blue-600 font-semibold px-7 py-3 rounded-lg transition-colors text-sm",
                            children: "See all success stories →"
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 5467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useInView; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);



var useInView = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isInView = ref1[0], setIsInView = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 1), entry = _param[0];
            if (entry.isIntersecting) {
                setIsInView(true);
                observer.unobserve(entry.target); // remove if you want it to trigger only once
            }
        }, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            threshold: 0.1
        }, options));
        if (ref.current) observer.observe(ref.current);
        return function() {
            return observer.disconnect();
        };
    }, []);
    return [
        ref,
        isInView
    ];
};


/***/ }),

/***/ 5344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var useScreenSize = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), screenSize = ref[0], setScreenSize = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleResize = function() {
            var screenWidth = window.innerWidth;
            var size = "";
            if (screenWidth < 480) {
                size = "sm";
            } else if (screenWidth >= 440 && screenWidth < 768) {
                size = "md";
            } else if (screenWidth >= 768 && screenWidth < 992) {
                size = "lg";
            } else {
                size = "xl";
            }
            setScreenSize(size);
        };
        handleResize(); // Initial call to set screen size on component mount
        window.addEventListener("resize", handleResize);
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, []); // Empty dependency array to run the effect only once on component mount
    return screenSize;
};
/* harmony default export */ __webpack_exports__["Z"] = (useScreenSize);


/***/ }),

/***/ 9738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ManagedServices; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_blogUtils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1180);
/* harmony import */ var _blogs_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2684);
/* harmony import */ var _components_services_Service2__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3230);
/* harmony import */ var _components_trust_SuccessStoryEmbed__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2100);
/* harmony import */ var _components_services_ServiceFAQ__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2616);
/* harmony import */ var _components_ai_agent_demo_CustomerSection__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4837);








var Capabilities2 = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5791), __webpack_require__.e(8388), __webpack_require__.e(5290), __webpack_require__.e(7517), __webpack_require__.e(7113)]).then(__webpack_require__.bind(__webpack_require__, 7517));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7517)
            ];
        }
    },
    ssr: false
});



var Footer = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 2941).then(__webpack_require__.bind(__webpack_require__, 3193));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3193)
            ];
        }
    },
    ssr: false
});
ManagedServices.title = "Managed IT Services & Operations Support India | ITMTB";
ManagedServices.desc = "Managed IT operations for Indian companies with live systems and no internal tech team — yearly engagements with weekly reporting, defined escalation handling, and proactive monitoring across application, infrastructure, and AI components.";
ManagedServices.header_img = "https://www.itmtb.com/services/capability/managed-services.webp";
ManagedServices.keywords = "managed IT services India enterprise, end-to-end IT management services, IT operations support India, managed services India enterprise, yearly managed services engagement India, application monitoring production support India, IT operations outsourcing India, DevOps managed services India, 24x7 IT support India, infrastructure monitoring India";
var faqItems = [
    {
        q: "How is your managed services delivery different from a typical offshore IT support vendor?",
        a: "ITMTB managed services are structured around defined operational cadences rather than reactive ticket resolution. Every engagement includes weekly status reporting covering open incidents, prioritised backlog, deployment activity, infrastructure cost trends, and planned changes for the coming week. Monthly and quarterly reviews are structured — with a dedicated roadmap discussion at each quarterly cycle. Teams maintain written incident response runbooks specific to each system, and escalation paths are defined before incidents occur. For systems that include AI or automation components, monitoring extends to output quality sampling, API schema drift, and inference cost anomalies — failure modes that do not surface in standard infrastructure metrics. The result is an engagement where your operations team has predictable, documented visibility rather than ad-hoc incident notifications."
    },
    {
        q: "What does a managed services engagement typically include?",
        a: "A managed services engagement at ITMTB typically covers: application monitoring, production support and issue resolution, maintenance and bug fixes, infrastructure support, security updates, enhancement planning, operational reporting, issue prioritisation, and release coordination. The exact scope is defined during the initial engagement planning phase and formalised in a services agreement. Engagements also include governance structure: weekly reporting cadence, task scoping workflows, escalation handling procedures, roadmap discussions, and operational review schedules — the layer that determines how work is prioritised, escalated, and reported, not just whether individual incidents are closed."
    },
    {
        q: "How do you handle 24\xd77 monitoring and incident response for Indian enterprises?",
        a: "24\xd77 monitoring is implemented through a combination of automated alerting and on-call rotation. For infrastructure: we configure alerting in your cloud environment (AWS CloudWatch, Azure Monitor, GCP Cloud Monitoring) with thresholds for availability, latency, error rate, and cost. Critical alerts page an on-call engineer immediately; non-critical alerts are aggregated into a daily review. For AI systems: we add LLM-specific monitoring (output quality sampling, prompt injection detection, inference cost) on top of standard infrastructure metrics. Incident response: every production system we manage has a written incident response runbook specific to its failure modes — not a generic process. Response SLA is defined in the managed services agreement; critical production incidents receive an immediate response within the agreed window. Reporting: monthly operational reports covering uptime, incident summary, and performance trends."
    },
    {
        q: "Can you take over operations for a system that was built by another team?",
        a: "Yes — but the transition requires a structured handover process. We conduct a system audit during transition: architecture review, dependency mapping, documentation gap assessment, and a shadow period where we observe the system under normal conditions before taking operational responsibility. This is important because undocumented behaviour and tribal knowledge are the largest risks when transitioning operations between teams. For AI systems specifically, we need to understand the training data assumptions, any known failure modes, and any manual interventions the previous team was performing regularly. After the audit, we produce an updated operations runbook and take over responsibility under a defined SLA. We have completed operational transitions for production AI systems, cloud infrastructure, and enterprise applications — including systems with limited documentation."
    },
    {
        q: "How do you apply automation in managed services without compromising operational governance?",
        a: "Automation is applied selectively to tasks where it reduces routine overhead without introducing operational risk. ITMTB uses Orchestrik for specific automation activities including monitoring workflows, support routing, issue triaging, and coordination of repetitive operational processes. The goal is to reduce manual coordination overhead and processing delays — not to automate decision-making or replace the governance layer. Escalation handling, prioritisation decisions, and roadmap discussions remain human-led. For each automation applied, we document what is automated, the trigger conditions, the expected behaviour, and the escalation path when the automation encounters an unexpected state. Automation is transparent and auditable, not a black box running alongside your operations."
    },
    {
        q: "What does managing AI components in production actually involve?",
        a: "Running AI components in production requires monitoring for failure modes that do not trigger conventional alerting. Model drift: model behaviour changes when the underlying LLM is updated by the provider, or when the distribution of inputs changes over time. We monitor for output distribution shifts that indicate the system's behaviour has changed materially. Prompt injection risks: production AI systems receive inputs from the external world; some of those inputs will attempt to redirect system behaviour. We monitor logs for injection patterns and alert when unusual sequences occur. API dependency changes: AI systems depend on external APIs whose response schemas change. We monitor for schema drift and alert before it causes failures. Inference cost spikes: AI systems with variable-length outputs or multi-step reasoning can generate unexpected cost spikes. We implement cost guardrails and alert on spend anomalies. For a global intelligence firm, we deployed and have operated four production AI models covering automated risk reports, document analysis, and business intelligence — all in continuous operation."
    },
    {
        q: "What is a warranty period and when does it apply?",
        a: "A warranty period is a defined window after production deployment during which the build team fixes bugs and regressions at zero additional cost. On ITMTB engagements where we have built the system, the warranty period is 4–8 weeks post-handoff. This covers: bugs in the delivered software, regressions in previously working functionality, and production incidents caused by issues in the delivered code or configuration. The warranty period applies to ITMTB-built systems only. For operational transitions where ITMTB is taking over a system built by another team, the transition audit establishes the operational baseline and SLA scope before operational responsibility is assumed."
    }, 
];
ManagedServices.faq = faqItems;
var jsonLd = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Managed IT Services & Operations Support",
    "provider": {
        "@type": "Organization",
        "name": "ITMTB",
        "url": "https://www.itmtb.com",
        "logo": "https://www.itmtb.com/logo.webp",
        "sameAs": [
            "https://www.linkedin.com/company/itmtb-technologies/",
            "https://x.com/ITMTBTech", 
        ]
    },
    "areaServed": {
        "@type": "Country",
        "name": "India"
    },
    "serviceType": "Managed IT Services",
    "description": "IT operations management and managed services for organisations outsourcing technology development and support — yearly engagement models with defined reporting cadences, escalation handling, and automation-assisted workflows.",
    "offers": {
        "@type": "Offer",
        "priceSpecification": {
            "@type": "PriceSpecification",
            "description": "Custom — annual retainer based on scope"
        }
    }
};
var activities = [
    "Application monitoring",
    "Production support",
    "Maintenance & bug fixes",
    "Infrastructure support",
    "Enhancement planning",
    "Security updates",
    "Operational reporting",
    "Issue prioritisation",
    "Release coordination", 
];
var cadenceColumns = [
    {
        period: "Weekly",
        items: [
            "Open incidents with current status",
            "Backlog prioritisation changes",
            "Deployments completed in the past week",
            "Infrastructure cost trend",
            "Planned changes for the coming week", 
        ]
    },
    {
        period: "Monthly",
        items: [
            "Uptime and availability summary",
            "Incident analysis and resolution review",
            "Patch and security update status",
            "Enhancement pipeline progress",
            "Cost optimisation actions taken", 
        ]
    },
    {
        period: "Quarterly",
        items: [
            "Operational priorities review",
            "System requirements assessment",
            "Roadmap discussion and planning",
            "SLA performance review",
            "Optimisation recommendations", 
        ]
    }, 
];
var comparisonRows = [
    {
        label: "Response model",
        col1: "Reactive — you raise a ticket, vendor resolves within SLA",
        col2: "Proactive — continuous monitoring with defined alerting and resolution cadence",
        col3: "Proactive + automated triage and routing for common failure patterns"
    },
    {
        label: "Reporting cadence",
        col1: "On request, or at incident close",
        col2: "Weekly, monthly, and quarterly structured reports",
        col3: "Same, with automated data aggregation for monitoring dashboards"
    },
    {
        label: "Escalation structure",
        col1: "Ad hoc",
        col2: "Written escalation matrix, defined at engagement start",
        col3: "Same"
    },
    {
        label: "Cost management",
        col1: "Not included",
        col2: "Regular cloud cost reviews and optimisation actions",
        col3: "Continuous automated cost monitoring with anomaly alerting"
    },
    {
        label: "Roadmap discussions",
        col1: "Not included",
        col2: "Quarterly, structured around system priorities and enhancement pipeline",
        col3: "Quarterly"
    },
    {
        label: "Engagement model",
        col1: "Per incident or time-and-materials",
        col2: "Annual retainer",
        col3: "Annual retainer"
    }, 
];
var transitionPhases = [
    {
        phase: "01",
        title: "Audit & Discovery",
        duration: "Weeks 1–2",
        items: [
            "Architecture review and dependency mapping",
            "Documentation gap assessment",
            "Known failure mode and incident history review",
            "Tribal knowledge sessions with the outgoing team",
            "Monitoring and alerting configuration audit", 
        ]
    },
    {
        phase: "02",
        title: "Shadow Period",
        duration: "Weeks 3–4",
        items: [
            "Observe system under normal operating conditions",
            "Joint incident handling with current team",
            "Runbook drafting from observed operations",
            "Monitoring threshold calibration", 
        ]
    },
    {
        phase: "03",
        title: "Phased Handover",
        duration: "Weeks 5–6",
        items: [
            "Updated operations runbook finalised",
            "SLA definitions agreed and documented",
            "On-call rotation established",
            "First weekly operational report issued", 
        ]
    },
    {
        phase: "04",
        title: "Steady-State Operations",
        duration: "Ongoing",
        items: [
            "Weekly reporting cadence active",
            "Monthly operational reviews",
            "Quarterly roadmap discussions",
            "Continuous cost and reliability optimisation cycle", 
        ]
    }, 
];
var subServices = [
    {
        img: null,
        key: "Application, Infrastructure & Website Monitoring",
        title: "Continuous monitoring across your application and infrastructure layer, with alerting configured to your system's specific failure modes.",
        text: "We configure monitoring across cloud environments using AWS CloudWatch, Azure Monitor, and GCP Cloud Monitoring, supplemented by Datadog, Grafana, Prometheus, Sentry, and PagerDuty where appropriate. This covers websites and web applications as well — uptime monitoring, error-rate tracking (4xx/5xx responses), Core Web Vitals, and page performance alongside backend infrastructure health. Alerting is threshold-based and specific to each system — not generic CPU and memory alerts.\n\nFor systems with AI or automation components, monitoring extends to output quality sampling, inference cost trends, and API schema drift — failure modes that do not surface in standard infrastructure metrics. Critical alerts trigger immediate response; non-critical issues are aggregated into the weekly operational review."
    },
    {
        img: null,
        key: "Production Support & Issue Resolution",
        title: "SLA-defined issue resolution with a written escalation matrix established at the start of each engagement.",
        text: "Production support is structured around a documented escalation matrix — not an ad-hoc ticketing queue. Severity classifications, response windows, and escalation paths are defined before incidents occur. Every system we manage has an incident response runbook specific to its failure modes.\n\nMonthly operational reports summarise incident volume, severity distribution, resolution time, and recurring failure patterns — so you can track whether operational health is improving over time, not just whether individual tickets are closed."
    },
    {
        img: null,
        key: "Release Engineering & DevOps Operations",
        title: "CI/CD pipeline maintenance, dependency management, security patching, and coordinated release operations.",
        text: "We manage the infrastructure and release engineering that product teams typically treat as overhead: CI/CD pipeline maintenance, dependency and security patch management, environment provisioning, database operations (backups, schema migrations, performance reviews), and coordinated release scheduling.\n\nRelease coordination is included in the weekly operational report — your stakeholders see what is being deployed, when, and what was verified before release."
    },
    {
        img: null,
        key: "Operational Reporting & Reviews",
        title: "Weekly, monthly, and quarterly operational reporting — structured around what your stakeholders need to track.",
        text: "Weekly reports cover: open incidents with current status, backlog prioritisation changes, deployments in the past week, infrastructure cost trends, and planned changes for the coming week.\n\nMonthly reports cover: uptime and availability, incident analysis, patch and security update status, enhancement pipeline progress, and cost optimisation actions taken.\n\nQuarterly reviews include a roadmap discussion: whether operational priorities were addressed, what has changed in system requirements, and what the operational focus for the next quarter should be."
    },
    {
        img: null,
        key: "Cost & Reliability Optimisation",
        title: "Regular cost reviews and reliability improvements as a continuous part of managed operations — not a one-off exercise.",
        text: "Cloud infrastructure costs grow faster than usage when not actively managed. As part of managed services, we run regular cost reviews: right-sizing compute resources, implementing storage lifecycle policies, identifying idle endpoints and unused environments, and reviewing infrastructure architecture for reliability improvements.\n\nFor systems with AI components, inference cost management requires specific attention — usage growth, model updates, and architectural changes can produce significant cost changes that are not visible in standard cloud billing reviews."
    },
    {
        img: null,
        key: "Operational Automation",
        title: "Selective automation of routine operational tasks to reduce manual overhead and improve response consistency.",
        text: "Automation is applied to well-defined operational tasks where it reduces coordination overhead without introducing governance risk. This includes monitoring workflow automation, support request routing, issue triage for common failure patterns, and coordination of repetitive processes.\n\nWhere ITMTB's Orchestrik platform is used for automation, it operates as a separate product layer with its own defined scope and terms. All automation is documented: what is automated, the trigger conditions, expected behaviour, and escalation path for unexpected states. Automation in managed services does not replace operational governance."
    },
    {
        img: null,
        key: "Warranty Coverage",
        title: "Applicable to systems built by ITMTB — a 4–8 week post-deployment warranty covering bugs and regressions at zero additional cost.",
        text: "For engagements where ITMTB has built the system being managed, a 4–8 week warranty period is included post-deployment. During this window, bugs in the delivered software and regressions in previously working functionality are fixed at no additional charge.\n\nThe warranty period applies to ITMTB-built systems only. For operational transitions where we are taking over a system built by another team, the transition audit establishes the operational baseline and SLA scope before operational responsibility is assumed."
    }, 
];
function ManagedServices() {
    var insights = _blogs_json__WEBPACK_IMPORTED_MODULE_4__.filter(function(item) {
        var ref;
        return ![
            "case-study",
            "tech"
        ].includes(item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category);
    });
    var caseStudies = _blogs_json__WEBPACK_IMPORTED_MODULE_4__.filter(function(item) {
        var ref;
        return (item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category) === "case-study";
    });
    var filteredInsights = insights.filter(function(item) {
        var ref, ref1;
        return item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : (ref1 = ref.refer) === null || ref1 === void 0 ? void 0 : ref1.includes("Managed Services");
    });
    var filteredCaseStudies = caseStudies.filter(function(item) {
        var ref, ref1;
        return item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : (ref1 = ref.refer) === null || ref1 === void 0 ? void 0 : ref1.includes("Managed Services");
    });
    if (filteredInsights.length === 1) {
        insights = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(filteredInsights).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_10__/* .getRandom */ .s)(insights.filter(function(item) {
            return !filteredInsights.includes(item);
        }), 1)));
    } else if (filteredInsights.length >= 2) {
        insights = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_10__/* .getRandom */ .s)(filteredInsights, 2);
    } else {
        insights = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_10__/* .getRandom */ .s)(insights, 2);
    }
    if (filteredCaseStudies.length === 1) {
        caseStudies = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(filteredCaseStudies).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_10__/* .getRandom */ .s)(caseStudies.filter(function(item) {
            return !filteredCaseStudies.includes(item);
        }), 1)));
    } else if (filteredCaseStudies.length >= 2) {
        caseStudies = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_10__/* .getRandom */ .s)(filteredCaseStudies, 2);
    } else {
        caseStudies = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_10__/* .getRandom */ .s)(caseStudies, 2);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(jsonLd)
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_Service2__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                heading: "Managed IT Services & Operations Support India",
                paragraph: "Technology Managed Services means handing off the day-to-day IT operations of your applications, infrastructure, and workflows to a dedicated team — so your organisation can focus on its core business without building or scaling an internal tech team. It is end-to-end IT management: monitoring, support, escalation, and reporting run as one accountable engagement rather than a stack of disconnected vendors.<br/><br/>ITMTB provides Managed Services for companies so they don't have to invest in in-house IT teams for managing their software. We handle monitoring, incident response, escalation, and release coordination so production systems stay stable and accountable.<br/><br/>Engagements include weekly reporting, a written escalation matrix, structured monthly reviews, and quarterly roadmap discussions.",
                primaryCta: null,
                heroSvg: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    viewBox: "0 0 440 400",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    className: "w-full max-w-md opacity-70",
                    "aria-hidden": "true",
                    role: "presentation",
                    children: [
                        (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(Array(6)).map(function(_, row) {
                            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(Array(7)).map(function(_, col) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                    cx: 40 + col * 60,
                                    cy: 40 + row * 60,
                                    r: "1.5",
                                    fill: "#e2e8f0"
                                }, "".concat(row, "-").concat(col));
                            });
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 90 100 C 140 80 180 68 220 60",
                            stroke: "#e2e8f0",
                            strokeWidth: "1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 350 100 C 308 80 268 68 220 60",
                            stroke: "#e2e8f0",
                            strokeWidth: "1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 60 220 C 72 268 96 298 130 330",
                            stroke: "#e2e8f0",
                            strokeWidth: "1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 380 220 C 368 268 344 298 310 330",
                            stroke: "#e2e8f0",
                            strokeWidth: "1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 130 330 C 190 345 250 345 310 330",
                            stroke: "#e2e8f0",
                            strokeWidth: "1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 220 200 C 220 162 220 120 220 60",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 220 200 C 178 168 138 138 90 100",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 220 200 C 262 168 302 138 350 100",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 220 200 C 165 202 115 210 60 220",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 220 200 C 275 202 325 210 380 220",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 220 200 C 192 242 165 284 130 330",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 220 200 C 248 242 272 284 310 330",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "220",
                            cy: "60",
                            r: "7",
                            stroke: "#94a3b8",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "90",
                            cy: "100",
                            r: "9",
                            stroke: "#94a3b8",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "350",
                            cy: "100",
                            r: "9",
                            stroke: "#94a3b8",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "60",
                            cy: "220",
                            r: "7",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "380",
                            cy: "220",
                            r: "7",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "130",
                            cy: "330",
                            r: "9",
                            stroke: "#94a3b8",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "310",
                            cy: "330",
                            r: "9",
                            stroke: "#94a3b8",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "220",
                            cy: "60",
                            r: "3",
                            fill: "#cbd5e1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "90",
                            cy: "100",
                            r: "3.5",
                            fill: "#cbd5e1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "350",
                            cy: "100",
                            r: "3.5",
                            fill: "#cbd5e1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "130",
                            cy: "330",
                            r: "3.5",
                            fill: "#cbd5e1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "310",
                            cy: "330",
                            r: "3.5",
                            fill: "#cbd5e1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "90",
                            cy: "100",
                            r: "16",
                            stroke: "#94a3b8",
                            strokeWidth: "0.8",
                            strokeOpacity: "0.4",
                            strokeDasharray: "3 3"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "350",
                            cy: "100",
                            r: "16",
                            stroke: "#94a3b8",
                            strokeWidth: "0.8",
                            strokeOpacity: "0.4",
                            strokeDasharray: "3 3"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "130",
                            cy: "330",
                            r: "16",
                            stroke: "#94a3b8",
                            strokeWidth: "0.8",
                            strokeOpacity: "0.4",
                            strokeDasharray: "3 3"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "220",
                            cy: "200",
                            r: "24",
                            stroke: "#b45309",
                            strokeWidth: "1",
                            strokeOpacity: "0.3",
                            strokeDasharray: "5 3"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "220",
                            cy: "200",
                            r: "18",
                            stroke: "#b45309",
                            strokeWidth: "2"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "220",
                            cy: "200",
                            r: "7",
                            fill: "#b45309",
                            fillOpacity: "0.15",
                            stroke: "#b45309",
                            strokeWidth: "1.5"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                className: "bg-white border-b border-gray-100 px-6 md:px-[60px] py-2 overflow-x-auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex gap-6 text-sm font-medium whitespace-nowrap",
                    children: [
                        {
                            label: "Who it's for",
                            href: "#who-its-for"
                        },
                        {
                            label: "What's included",
                            href: "#whats-included"
                        },
                        {
                            label: "How transitions work",
                            href: "#transitions"
                        },
                        {
                            label: "Support models compared",
                            href: "#comparison"
                        },
                        {
                            label: "FAQ",
                            href: "#faq"
                        }, 
                    ].map(function(param) {
                        var label = param.label, href = param.href;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: href,
                            className: "text-gray-500 hover:text-indigo-600 transition-colors py-1",
                            children: label
                        }, href);
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "-mt-5",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ai_agent_demo_CustomerSection__WEBPACK_IMPORTED_MODULE_8__/* .CustomerSection */ .a, {
                    title: "Trusted by"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                id: "who-its-for",
                className: "scroll-mt-24 px-8 md:px-[60px] py-14 bg-white border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-4xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-8",
                            children: "Who This Is For"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "space-y-8",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-lg md:text-xl font-semibold text-gray-900 mb-2",
                                            children: "Companies already working with outsourced software vendors in India"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-base md:text-lg text-gray-700 leading-relaxed",
                                            children: "If a separate vendor built or continues to build your software, the operational layer is usually missing — most build-side agreements stop at delivery. Managed services adds the monitoring, reporting, and escalation structure that keeps production systems accountable to your business rather than to a development backlog."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-lg md:text-xl font-semibold text-gray-900 mb-2",
                                            children: "Companies running live websites, portals, applications, or internal tools"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-base md:text-lg text-gray-700 leading-relaxed",
                                            children: "Once a system is in production, uptime, performance, security patching, and cloud cost control become continuous operational obligations. We take ownership of those activities under a yearly engagement, so the systems your customers and staff depend on each day have a defined operations team behind them."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-lg md:text-xl font-semibold text-gray-900 mb-2",
                                            children: "Companies where ongoing IT support has become informal or vendor-dependent"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-base md:text-lg text-gray-700 leading-relaxed",
                                            children: "When support consists of WhatsApp messages, ad-hoc tickets, or whoever picks up the phone, incidents stack up quietly and root causes never get addressed. Managed services replaces that informality with a written escalation matrix, a prioritised backlog, and structured weekly reporting — so leadership knows exactly where things stand."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-lg md:text-xl font-semibold text-gray-900 mb-2",
                                            children: "Companies that need predictable reporting, escalation, and operational ownership"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-base md:text-lg text-gray-700 leading-relaxed",
                                            children: "CTOs, COOs, and CFOs at mid-sized Indian enterprises need visibility into what is changing, what broke, and what it costs — without chasing it down. Every engagement includes weekly status reports, monthly operational reviews, and quarterly roadmap discussions so operational health is observable at a glance, in board-ready format."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-lg md:text-xl font-semibold text-gray-900 mb-2",
                                            children: "Companies without an internal tech team — or not ready to hire one"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-base md:text-lg text-gray-700 leading-relaxed",
                                            children: "Building an internal IT team in India typically means 6–12 months to recruit a CTO and supporting engineers, plus payroll, attrition, and management overhead. A managed services engagement provides equivalent operational coverage immediately, with the option to transition responsibilities to an in-house team later as it scales."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                id: "whats-included",
                className: "scroll-mt-24 px-8 md:px-[60px] py-14 bg-white",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-4xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-6",
                            children: "How Managed Services Reduce Long-Term Operational Burden"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-4",
                            children: "Software ownership does not end at deployment. Operational continuity often requires monitoring, maintenance, issue resolution, infrastructure support, enhancement planning, and ongoing optimisation."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-10",
                            children: "ITMTB offers yearly managed-services engagement models focused on operational continuity, predictable support, and lifecycle ownership."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-xs font-semibold uppercase tracking-widest text-gray-400 mb-5",
                            children: "Typical managed services activities"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 mb-10",
                            children: activities.map(function(activity) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center gap-3 bg-gray-50 border border-gray-100 rounded-lg px-4 py-3",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "w-1.5 h-1.5 rounded-full bg-indigo-400 flex-shrink-0"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-sm text-gray-700",
                                            children: activity
                                        })
                                    ]
                                }, activity);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed",
                            children: "Managed-services engagements include weekly reporting, task scoping, prioritisation workflows, escalation handling, roadmap discussions, and operational review cadence — helping organisations reduce operational uncertainty, support fragmentation, and long-term maintenance risk."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                id: "engage",
                className: "px-8 md:px-[60px] py-14 bg-gray-50 border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-5xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-3",
                            children: "Operational Cadence"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-600 text-base md:text-lg mb-10",
                            children: "Predictable reporting and review structure across every engagement — delivered from our India-based operations team during IST business hours, with 24\xd77 on-call rotation for production incidents."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-1 md:grid-cols-3 gap-6 mb-12",
                            children: cadenceColumns.map(function(cadence) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "bg-white border border-gray-200 rounded-xl p-6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-xs font-semibold uppercase tracking-widest text-indigo-500 mb-5",
                                            children: cadence.period
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            className: "space-y-3",
                                            children: cadence.items.map(function(item) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    className: "flex items-start gap-2 text-sm text-gray-700",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "mt-1.5 w-1 h-1 rounded-full bg-gray-400 flex-shrink-0"
                                                        }),
                                                        item
                                                    ]
                                                }, item);
                                            })
                                        })
                                    ]
                                }, cadence.period);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                id: "transitions",
                className: "scroll-mt-24 px-8 md:px-[60px] py-14 bg-gray-50 border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-5xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-3",
                            children: "How We Transition Operations from Another Provider"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-600 text-base md:text-lg mb-10",
                            children: "A structured four-phase process that establishes operational clarity before responsibility is transferred."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-1 md:grid-cols-2 gap-6",
                            children: transitionPhases.map(function(phase) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "bg-white border border-gray-200 rounded-xl p-6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex items-start gap-4 mb-5",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-3xl font-bold text-indigo-200 leading-none select-none",
                                                    children: phase.phase
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                            className: "text-base font-bold text-gray-900",
                                                            children: phase.title
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "text-xs text-indigo-500 font-medium mt-1",
                                                            children: phase.duration
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            className: "space-y-2.5",
                                            children: phase.items.map(function(item) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    className: "flex items-start gap-2 text-sm text-gray-700",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "mt-1.5 w-1 h-1 rounded-full bg-gray-400 flex-shrink-0"
                                                        }),
                                                        item
                                                    ]
                                                }, item);
                                            })
                                        })
                                    ]
                                }, phase.phase);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "text-gray-600 text-base md:text-lg mt-8",
                            children: [
                                "For a concrete example, see how we",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/blog/d2c-retail-technology-management-takeover",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "text-indigo-600 hover:text-indigo-800 font-medium transition-colors",
                                        children: "took over an undocumented D2C retail technology stack and turned it into a managed operation"
                                    })
                                }),
                                " ",
                                "— documentation, cloud migration, deployment modernization, and operations automation run as one engagement."
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_trust_SuccessStoryEmbed__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                referTag: "Managed Services",
                maxItems: 3,
                heading: "Selected managed services engagements"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-8 md:px-[60px] py-14 bg-white border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-4xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-6",
                            children: "How ITMTB uses automation to improve Managed Services Economics"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-4",
                            children: "Managed services are increasingly evolving through automation, operational orchestration, and AI-assisted workflows."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-4",
                            children: [
                                "ITMTB uses",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/orchestrik",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "text-indigo-600 hover:text-indigo-800 font-medium transition-colors",
                                        children: "Orchestrik"
                                    })
                                }),
                                " ",
                                "for selected automation activities where appropriate. These may include monitoring workflows, repetitive operational processes, support routing, issue triaging, and operational coordination. Orchestrik is a separate product with its own pricing and terms."
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-4",
                            children: "The goal is not replacing operational governance. The goal is reducing repetitive operational overhead while improving response efficiency and visibility."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed",
                            children: "Over time, operational automation can help reduce manual support load, repetitive coordination effort, and support-processing delays — extending operational capabilities into the managed services layer without replacing governance."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                id: "comparison",
                className: "scroll-mt-24 px-8 md:px-[60px] py-14 bg-white border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-6xl overflow-x-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-3",
                            children: "Managed Services vs Ticket-Based Support: What's the Difference?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-600 text-base mb-8",
                            children: "The structural differences between reactive ticket-based support and a managed operations engagement — across response model, reporting cadence, escalation structure, and cost management."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", {
                            className: "w-full border-collapse text-sm min-w-[640px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                        className: "border-b-2 border-gray-200",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                className: "text-left py-3 pr-6 w-[20%]"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                className: "text-left py-3 pr-6 text-gray-900 font-semibold w-[26%]",
                                                children: "Ticket-Based Support"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                className: "text-left py-4 pr-6 text-indigo-900 font-semibold w-[27%] bg-indigo-50 px-4",
                                                children: "Managed Services"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("th", {
                                                className: "text-left py-3 text-gray-900 font-semibold w-[27%]",
                                                children: [
                                                    "Managed Services",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                    "with Automation"
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
                                    children: comparisonRows.map(function(row, idx) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            className: idx % 2 === 0 ? "bg-gray-50/40" : "bg-white",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    className: "py-4 pr-6 text-gray-500 font-medium text-xs uppercase tracking-wide align-top border-b border-gray-100",
                                                    children: row.label
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    className: "py-4 pr-6 text-gray-600 leading-snug align-top border-b border-gray-100",
                                                    children: row.col1
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    className: "py-4 pr-6 text-gray-800 leading-snug bg-indigo-50/60 px-4 align-top font-medium border-b border-indigo-100",
                                                    children: row.col2
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    className: "py-4 text-gray-600 leading-snug align-top border-b border-gray-100",
                                                    children: row.col3
                                                })
                                            ]
                                        }, row.label);
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-8 md:px-[60px] py-14 bg-white border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-4xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-6",
                            children: "Engagement Model"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-4",
                            children: "ITMTB offers yearly managed-services engagement models focused on operational continuity, predictable support, and lifecycle ownership — delivered by India-based engineering and operations teams. Yearly engagements provide the operational stability required for consistent reporting cadences, structured reviews, and compounding optimisation."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-4",
                            children: "Engagement scope is defined through an initial discovery conversation. Pricing is driven by system complexity, monitoring surface, support volume, and reporting requirements — all assessed before a proposal is prepared."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed",
                            children: "Weekly reporting, task scoping workflows, prioritisation and escalation procedures, and quarterly roadmap discussions are included as standard — not as add-ons. Contracting, invoicing, and GST treatment follow standard India MSA terms."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Capabilities2, {
                dataList: subServices,
                bg: "bg-[#402A6A]",
                insights: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(caseStudies).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(insights)),
                hideFooter: true,
                hideCardSubtitle: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-8 md:px-[60px] py-14 bg-gray-50 border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-5xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-xs font-semibold uppercase tracking-widest text-gray-400 mb-7",
                            children: "Related capabilities"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-1 md:grid-cols-3 gap-5",
                            children: [
                                {
                                    href: "/services/custom-software-development",
                                    label: "Custom Software Development",
                                    desc: "Our core engineering practice — the systems we operate are often the ones we built. Greenfield platforms, customer-facing and operational systems, and AI-enabled products."
                                },
                                {
                                    href: "/services/cloud",
                                    label: "Cloud Infrastructure",
                                    desc: "Architecture, migration, and operations for the cloud layer your applications run on."
                                },
                                {
                                    href: "/services/cybersecurity",
                                    label: "Cybersecurity",
                                    desc: "Security operations, compliance monitoring, and risk management integrated into managed services."
                                },
                                {
                                    href: "/agentic-ai",
                                    label: "AI Agent Deployment",
                                    desc: "Deploying and operating AI agent systems in production — with managed operations included."
                                },
                                {
                                    href: "/services/data-center-project-readiness-governance",
                                    label: "Data Centre Readiness",
                                    desc: "Operations readiness and handover governance for organisations planning a captive, DR, or hybrid data centre setup."
                                }, 
                            ].map(function(link) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: link.href,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        className: "block bg-white border border-gray-200 rounded-xl p-6 hover:border-indigo-400 hover:shadow-sm transition-all group",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: "text-base font-semibold text-gray-900 group-hover:text-indigo-600 transition-colors mb-2",
                                                children: link.label
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-sm text-gray-500 leading-relaxed",
                                                children: link.desc
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "mt-4 inline-block text-sm font-semibold text-indigo-500 group-hover:text-indigo-700 transition-colors",
                                                children: "Learn more →"
                                            })
                                        ]
                                    })
                                }, link.href);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "faq",
                className: "scroll-mt-24",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_ServiceFAQ__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    items: faqItems
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-8 md:px-[60px] py-16 bg-[#0d0822]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-3xl mx-auto text-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-xs font-semibold uppercase tracking-widest text-indigo-400 mb-5",
                            children: "Start the conversation"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-white mb-5",
                            children: "Discuss a Managed Services Engagement"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-slate-300 text-base md:text-lg leading-relaxed mb-8",
                            children: "We assess your current operational setup, define scope, and prepare a proposal — no default contracts, no minimum headcount. Scope is driven by your system complexity and reporting requirements."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/contact-us?utm_source=service-managed-services&utm_content=bottom-cta",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "inline-block bg-[#f1aa4e] text-black font-semibold text-base px-8 py-3.5 rounded-md hover:bg-[#e09a3e] transition-colors",
                                children: "Request support model and pricing →"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Footer, {})
        ]
    });
};


/***/ }),

/***/ 1180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ getRandom; }
/* harmony export */ });
var getRandom = function(arr, n) {
    var result = new Array(n), len = arr.length, taken = new Array(len);
    if (n > len) throw new RangeError("getRandom: more elements taken than available");
    while(n--){
        var x = Math.floor(Math.random() * len);
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
    }
    return result;
};


/***/ }),

/***/ 1358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ namedClients; }
/* harmony export */ });
var namedClients = [
    {
        name: "Wright Research",
        logo: "/companies/wright.webp",
        url: "https://www.wrightresearch.in/"
    },
    {
        name: "Arete Labs",
        logo: "/companies/arete.webp",
        url: "https://www.arete-labs.com/"
    },
    {
        name: "Paterson Securities",
        logo: "/companies/Paterson.webp",
        url: "https://paterson.co.in/"
    },
    {
        name: "The Business Research Company",
        logo: "/companies/tbrc.avif",
        url: "https://www.thebusinessresearchcompany.com"
    },
    {
        name: "The Indian Garage Co.",
        logo: "/companies/tigc.svg",
        url: "https://tigc.in"
    },
    {
        name: "GlobalFair",
        logo: "/companies/globalfair.png",
        url: "https://www.myglobalfair.com"
    },
    {
        name: "Centre for Development of Advanced Computing",
        logo: "/companies/cdac.png",
        url: "https://www.cdac.in"
    },
    {
        name: "Aromathai Spa",
        logo: "/companies/aromathai.svg",
        url: "https://www.aromathai.com"
    },
    {
        name: "Corewellness",
        logo: "/companies/corewellness.png",
        url: "https://corefitplus.com"
    },
    {
        name: "Snuckworks Platforms",
        logo: "/companies/snuckworks.png",
        url: "https://snuckworks.com",
        darkBg: true
    },
    {
        name: "Fonepay",
        logo: "/companies/fonepay.webp",
        url: "#"
    }, 
];


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1608,8657,2684,9774,2888,179], function() { return __webpack_exec__(2258); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);